import {combineReducers} from 'redux';
import undoable, {ActionTypes, StateWithHistory} from 'redux-undo';
import {preloadedState as presentationReducerPreloadedState, presentationReducer, PresentationReducerState} from './reducer/presentation';
import {preloadedState as slideReducerPreloadedState, slideReducer, SlideReducerState} from './reducer/slide';
import {preloadedState as spinnerReducerPreloadedState, spinnerReducer, SpinnerReducerState} from './reducer/spinner';
import {languageReducer, LanguageReducerState, preloadedState as languageReducerPreloadedState} from './reducer/language';
import {gridReducer, GridReducerState, preloadedState as gridReducerPreloadedState} from './reducer/grid';
import {authReducer, AuthReducerState, preloadedState as authReducerPreloadedState} from './reducer/auth';
import {preloadedState as sidebarReducerPreloadedState, sidebarReducer, SidebarReducerState} from './reducer/sidebar';
import {connectionReducer, ConnectionReducerState, preloadedState as connectionReducerPreloadedState} from './reducer/connection.reducer';
import {preloadedState as userConfigPreloadedState, userConfigReducer, UserConfigReducerState} from './reducer/userConfig.reducer';
import {errorReducer, ErrorReducerState, preloadedState as errorReducerPreloadedState} from './reducer/error';
import {chartTypePreloadedState, chartTypeReducer, ChartTypeReducerState} from './reducer/pdfReport';
import {combinedSlideFilter} from './middleware/undoRedoMiddleware';
import editorReducer, {editorPreloadedState, EditorState} from './reducer/tiptapEditor.reducer';
import {flipCardInitialState, flipCardReducer, FlipCardState} from './reducer/flipCard.reducer';
import {htmlReducer, HtmlReducerState, preloadedState as htmlReducerPreloadedState} from './reducer/html.reducer';
import {IClipboardState, clipboardReducer, clipboardPreloadedState} from './reducer/clipboard.reducer';
import {viewReducer, viewReducerPreloadedState, ViewReducerState} from './reducer/view.reducer';

export interface AppState {
    gridReducer: GridReducerState;
    languageReducer: LanguageReducerState;
    presentationReducer: PresentationReducerState;
    slideReducer: StateWithHistory<SlideReducerState>;
    spinnerReducer: SpinnerReducerState;
    viewReducer: ViewReducerState;
    authReducer: AuthReducerState;
    sidebarReducer: SidebarReducerState;
    connectionReducer: ConnectionReducerState;
    userConfigReducer: UserConfigReducerState;
    errorReducer: ErrorReducerState;
    chartTypeReducer: ChartTypeReducerState;
    editorReducer: EditorState;
    flipCardReducer: FlipCardState;
    htmlReducer: HtmlReducerState;
    clipboardReducer: IClipboardState;
}

const reducer = combineReducers({
    presentationReducer,
    slideReducer: undoable(slideReducer, {
        limit: 30,
        undoType: ActionTypes.UNDO,
        redoType: ActionTypes.REDO,
        filter: combinedSlideFilter,
    }),
    spinnerReducer,
    languageReducer,
    gridReducer,
    authReducer,
    sidebarReducer,
    connectionReducer,
    userConfigReducer,
    errorReducer,
    chartTypeReducer,
    editorReducer,
    flipCardReducer,
    htmlReducer,
    clipboardReducer,
    viewReducer,
});

export const reducerPreloadedState: AppState = {
    presentationReducer: presentationReducerPreloadedState,
    slideReducer: {
        past: [] as SlideReducerState[],
        present: slideReducerPreloadedState,
        future: [] as SlideReducerState[],
    },
    spinnerReducer: spinnerReducerPreloadedState,
    languageReducer: languageReducerPreloadedState,
    gridReducer: gridReducerPreloadedState,
    authReducer: authReducerPreloadedState,
    sidebarReducer: sidebarReducerPreloadedState,
    connectionReducer: connectionReducerPreloadedState,
    userConfigReducer: userConfigPreloadedState,
    errorReducer: errorReducerPreloadedState,
    chartTypeReducer: chartTypePreloadedState,
    editorReducer: editorPreloadedState,
    flipCardReducer: flipCardInitialState,
    htmlReducer: htmlReducerPreloadedState,
    clipboardReducer: clipboardPreloadedState,
    viewReducer: viewReducerPreloadedState,
};

export default reducer;
